"use client";

import React from "react";
import { ArrowRight, Clock, Leaf, TrendingUp, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  icon: Leaf,
  metric: "100%",
  title: "RNCP & RS",
  description: "Ingénierie de certification rigoureuse pour la réussite de vos titres."
}, {
  icon: TrendingUp,
  metric: "+40%",
  title: "Performance",
  description: "Optimisation stratégique de vos processus de formation continue."
}, {
  icon: Clock,
  metric: "0",
  title: "Risque Juridique",
  description: "Veille réglementaire et conformité Qualiopi sans compromis."
}, {
  icon: Users,
  metric: "B2B",
  title: "Conseil Stratégique",
  description: "Accompagnement sur mesure pour vos projets de transformation."
}];
export default function FeatureHighlight() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}